

const page_strings = {
	"menu_item_developer" : "開發者專區", // 首頁上方選單
	"menu_item_service" : "服務項目", // 首頁上方選單
	"menu_item_brands" : "支援品牌", // 首頁上方選單
	"menu_item_medium" : "科普文章", // 首頁上方選單
	"menu_item_home" : "回到首頁", // 支援品項上方選單

	"page_company_name" : "台灣智慧家庭", // 公司名稱
	// fallback: page_title
	"page_title" : "MAKE SMART HOME SMARTER", // 首頁標語
	"page_subtitle" : "在一支APP內控制智慧家庭", // 首頁副標語
	"download_on": "DOWNLOAD ON",
	"our_service_title" : "我們的服務", // 服務頁標題
	"our_service_subtitle" : "你可以和 TIH 合作什麼", // 服務頁副標題
	"MaidWhite" : "Maid White", // Maid White 項目標題
	"maid_white_desc" : "Maid White 是個整合物聯網 (IoT) 軟體協定的平台。\n\n使用 Maid White的家電廠商，或是任何感興趣的開發者，皆可以透過 RESTful API 輕鬆地控制物聯網設備，無需學習例如 MQTT 或是其他公司自行開發的協定。", // Maid White 項目內文
	"meet_it" : "了解更多", // MaidWhit項目底部
	"irharuka_link_text": "認識小遙",//I.R. Haruka連結
	"app_dev" : "手機 APP 開發", // APP 開發項目標題
	"app_dev_desc" : "TIH 開發手機 APP，提供有關使用無線模組以及雲端的建議，並向有興趣進入物聯網領域的公司分享物聯網 APP 的實作經驗。", // APP 開發項目內文
	"irharuka_title" : "網紅小遙", // I.R. Haruka 項目標題
	"irharuka_desc" : "網紅小遙是一項結合手機APP和實體紅外線發射器，讓使用者能夠以網路遙控紅外線家電的服務。開源的軟硬體讓使用者可以自由修改細節以符合自己的需求。也可搭配TIH的開源紅外線資料庫IRDB，省去自行學習各式遙控器的麻煩。", // I.R. Haruka 項目內文
	"ryoku_simulator" : "Ryoku 模擬器", // Ryoku 模擬器標題
	"ryoku_simulator_desc" : "Ryoku 模擬器可以透過網頁協定，來協助使用者測試 Ryoku Cloud 以及 Maid White 的行為。\n\n軟體開發者可以透過 Ryoku 模擬器，來測試他們是否能夠成功的控制設備，以降低軟體開發成本。", // Ryoku 模擬器項目內文
	"about_numbers_title" : "數字會說話", // 數字會說話
	"about_numbers_subtitle" : "目前 TIH 的進度", // 數字會說話副標題
	"number_of_supported_brands" : "TIH 服務支援品牌數量", // 支援品牌數量
	"number_of_requests" : "有多少請求被傳送到了 TIH Cloud", // 請求數量
	"number_of_supported_devices" : "TIH Cloud 支援設備數量", // 設備支援數量
	"subscribe_by_email" : "訂閱電子報", // 訂閱電子報
	"subscribe_text_or" : "或", // 訂閱電子報或追蹤臉書的或
	"follow_us_on_facebook" : "在 Facebook 上追蹤我們", // 追蹤臉書
	"tih_copyright" : "Copyright © 2024 TIH Corp. 保留一切權利。", // 版權聲明
	"privacy_policy" : "隱私權政策", // 隱私政策連結
	"supported_brands_title" : "支援品牌", // 支援品項頁面首頁
	"model" : "型號", // 支援品項型號
	"device_type" : "設備類別", // 支援品項設備類別
	"remarks" : "備註", // 支援品項備註
	"popup_subtitle" : "幫您處理您的智慧家電", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_can_alse" : "Maid White 也可以", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_action_en" : "“Hey Google,Turn on the lamp.”", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_action_local" : "「幫我叫女僕小白。」", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_and_more" : "以及更多 ...", // 首頁點選MaidWhite Meet it的彈出視窗中






	"text_reveived_subscribe_mail_request" : "收到！", // 收到使用者要求訂閱電子報的訊息


	"html_description": "我們是台灣智慧家庭，致力於智慧家庭整合的公司，我們的宗旨是打造台灣軟體產業鍊。",
	"html_title": "台灣智慧家庭",
}

const privacy_policy ={

	"privacy_policy_title": "隱私權政策",
	"privacy_policy_version": "隱私權政策版本：2017101001-zh_tw",
	"privacy_policy_content_1": "台灣智慧家庭股份有限公司（Taiwan Intelligent Home Corp.，以下稱「TIH」、「我們」、「本公司」）尊重並承諾保護您的個人隱私。當您使用TIH的服務，即代表您同意TIH的隱私權政策；若您對我們的隱私權政策有任何疑問，歡迎來信洽詢；若您不同意我們的隱私權政策，請不要使用TIH的服務。",
	"privacy_policy_content_2_1": "我們所蒐集的資料及蒐集的方式",
	"privacy_policy_content_2_2_1": "當您使用TIH的服務，我們可能會收集以下資訊：",
	"privacy_policy_content_2_2_2_1": "電子信箱位址",
	"privacy_policy_content_2_2_2_2": "設備資料",
	"privacy_policy_content_2_2_2_3": "設備操作記錄",
	"privacy_policy_content_2_2_2_4": "網路傳輸請求，包括IP位址、瀏覽器類型、瀏覽器語言、日期與時間⋯⋯等",
	"privacy_policy_content_3_1": "我們如何使用您的資訊",
	"privacy_policy_content_3_2_1": "我們得將收集之資訊用於以下用途：",
	"privacy_policy_content_3_2_2_1": "提供、維持、改善產品與服務",
	"privacy_policy_content_3_2_2_2": "開發新產品與服務",
	"privacy_policy_content_3_2_2_3": "使用者體驗與市場分析",
	"privacy_policy_content_3_2_2_4_1": "在您同意下，提供您信任的第三方開發商進行設備操作的權限，權限包括：",
	"privacy_policy_content_3_2_2_4_2_1": "控制設備",
	"privacy_policy_content_3_2_2_4_2_2": "讀取設備狀態",
	"privacy_policy_content_3_2_2_4_2_3": "讀取設備操作記錄",
	"privacy_policy_content_3_2_2_5": "其它取得您同意的用途",
	"privacy_policy_content_3_2_2_6": "基於合法原因，提供資訊予有關當局",
	"privacy_policy_content_4_1": "跨境傳輸",
	"privacy_policy_content_4_2": "TIH使用位於不同國家、地區的伺服器，意即我們會在臺灣或者臺灣以外的伺服器處理您的個人資訊。",
	"privacy_policy_content_5_1": "Cookies及類似技術",
	"privacy_policy_content_5_2": "TIH 使用Cookie以進行OAuth登入及追蹤您的來訪次數、存取之頁面與功能。",


}

var strings = {...page_strings, ...privacy_policy}

export default strings;
